import React, { useState } from "react";
import Style from "./TermsofUse.module.scss";
import Button from "react-bootstrap/Button";
import Assets from "../../Layout/Assets";
import {
  Responsibilities,
  refund,
  Links,
} from "../../Constants/TermsAndConditions/Insideindia";
import { HmacSHA256 } from "crypto-js";

function InsideIndia() {
  const [InsideIndia, setTerms] = useState(true);

  return (
    <>
      <div>
        <h3 className={Style.headings}>Terms and Conditions</h3>
        <p className={Style.content}>
         <ul>
          <li>We as a merchant shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.</li>
          <li>Please review our Privacy Policy and Cancellation Policy.</li>
          <li>Aravind Hospital is not responsible / liable for the misuse of Tele-consultation facility provided</li>
          <li>Hospital is not liable if there is any connectivity problem or bandwidth interruption.</li>
          <li>Appointments once taken cannot be cancelled. It can however be rescheduled only with prior intimation before 48 hrs</li>
          <li>If the consultant is not available due to some emergency, an alternate doctor shall be engaged for the consultation</li>
          <li>If due to unforeseen circumstances the teleconsultations gets cancelled, an alternate slot depending upon availability and the patient's convenience shall be allowed.</li>
          <li>This is only can interactive session and does not involve any medico legal disputes.</li>
          <li>Please read any acknowledgement the "Terms and Conditions" given in the website before proceeding with the Teleconsultation.</li>
          <li>Please read the Patient Instruction Leaflet before the start of Teleconsultation.</li>
         </ul>
        </p>
      </div>

      <div>
        <h3 className={Style.headings}>Instructions</h3>
        <p>
        <ul>
          <li>Kindly report for the Tele-consultation on time.</li>
          <li>Please be precise and pass on important information in the order of priority. The advice given will depend upon the interaction made during the session.</li>
          <li>Please scan all the reports and relevant documents and keep readily available with you prior to the consultation or upload before consultation.</li>
          <li>Kindly make maximum use of the time provided to you. It could be better if you could write down everything which you need to communicate to the consultant.</li>
          <li>There is a facility to upload documents through this portal which you could judiciously avail.</li>
          <li>If you have not been able to follow / understand what has been told, please clarify immediately.</li>
          <li>Kindly get in touch with the Telemedicine Help Desk for any queries or assistance.</li>
        </ul>
        </p>
      </div>

    

      <div>
        <h3 className={Style.headings}>Privacy Policy</h3>
        <p className={Style.content}>
        We use a secure server for credit card transactions to protect the credit card information of our users. The information we gather from members is not shared with any individual or organization. We also do not sell, rent, or loan any identifiable information at the individual level to any third party.
        </p>
       
      </div>
      <div>
        <h3 className={Style.headings}> Cancellation Policy</h3>
        <p className={Style.content}>
        No Cancellation. Once you register for the Telemedicine facility, it cannot be cancelled.
          </p>
         
      </div>
      <div>
        <h3 className={Style.headings}>Refund Policy</h3>
        <p className={Style.content}>
        There is no refund option available for this telemedicine facility. The amount paid for registering for the telemedicine facility will not be refunded under any circumstances.
        </p>
       
      </div>
      

      
    </>
  );
}

export default InsideIndia;
